// extracted by mini-css-extract-plugin
export default {"heading":"shipping-address__heading__phXpZ","address":"shipping-address__address__AlJlx"};